import {
    VRow, VCol, VTable, VCard, VCardTitle, VCardText, VSheet, VBtn
} from 'vuetify/components'

export default defineNuxtPlugin(() => {
    console.log('[Component parser]: Init.');
    const componentMap: Record<string, any> = {
        'v-row': VRow,
        'v-col': VCol,
        'v-table': VTable,
        'v-card': VCard,
        'v-card-title': VCardTitle,
        'v-card-text': VCardText,
        'v-sheet': VSheet,
        'v-btn': VBtn
    }

    const parseProps = (str: string) => {
        const tagMatch = str.match(/^<([\w-]+)([^>]*)>/);
        if (!tagMatch) return {};

        const props: Record<string, any> = {};
        const regex = /([\w-]+)(?:="([^"]*)")?/g;

        let match: RegExpExecArray | null;

        while ((match = regex.exec(tagMatch[2])) !== null) {
            const attribute: string = match[1]!;
            let value: any = match[2];

            if (!value) {
                value = true;
            }

            props[attribute] = value;
        }

        return props;
    }

    const parseSlotContent = (content: string): any[] => {
        const children: any[] = []

        // Regex matches:
        // 1. Normal tags: <tag>...</tag>
        // 2. Self-closing tags: <tag ... />
        // 3. Text outside of tags
        const regex = /<([\w-]+)([^>]*)>([\s\S]*?)<\/\1>|<([\w-]+)([^>]*)\/>|([^<]+)/g
        let match: RegExpExecArray | null

        while ((match = regex.exec(content)) !== null) {
            if (match[1]) {
                // Normal tag <tag>...</tag>
                const tag = match[1].toLowerCase()
                const propsString = match[2]
                const inner = match[3]

                // Recursively parse the component string
                const childFn = parseComponentString(`<${tag}${propsString}>${inner}</${tag}>`)
                children.push(childFn())
            } else if (match[4]) {
                // Self-closing tag <tag ... />
                const tag = match[4].toLowerCase()
                const propsString = match[5]

                // Parse self-closing component
                const childFn = parseComponentString(`<${tag}${propsString}/>`)
                children.push(childFn())
            } else if (match[6]) {
                // Text outside of tags
                const text = match[6];
                if (text) children.push(text);
            }
        }

        return children
    }

    const parseComponentString = (str: string) => {
        const nameMatch: RegExpMatchArray | null = str.match(/^<([\w-]+)/);

        if (!nameMatch) return () => null;

        const name = nameMatch[1]!.toLowerCase();
        const component = componentMap[name] ?? name;
        const props = parseProps(str);

        const slotMatch = str.match(/>([\s\S]*)<\/[\w-]+>$/);
        const slotContent: string = slotMatch?.[1] ?? '';
        const children = parseSlotContent(slotContent);

        return () => h(component, props, { default: () => children })
    }

    return {
        provide: {
            componentParser: (str: string) => parseComponentString(str)
        }
    }
})
